
/*
    Display the list of location messages as MessageLocationData components 
    within a SingleOpenList component 
*/

import React from "react";

import MainContext from "../MainContext";

import VerticalLayout from "../Components/VerticalLayout";
import SingleOpenList from "../Components/SingleOpenList";

import MessageLocationData from "../DataDisplay/MessageLocationData";

import { getLocationMessages } from "../Requests/MessageRequests";

export default class MessagesLocationPage extends React.Component {

    static contextType = MainContext;

    state = {
        messages: []
    }

    loadMessages = (callback) => {

        const request = () => getLocationMessages();

        const then = ({data}) => {
            console.log("location messages", data);
            this.setState({messages: data}, () => {
                if(callback && typeof callback === "function"){
                    callback();
                }
            });
        };

        this.context.runProcessing(request, then, "getLocationMessages");
    }

    componentDidMount(){
        this.loadMessages();
    }

    render() {
        return (
            <VerticalLayout firstHeight={0}>
                <div className="content">
                    <SingleOpenList 
                        data={this.state.messages} 
                        component={MessageLocationData} 
                        props={{
                            reload: this.loadMessages
                        }}
                    />
                </div>
            </VerticalLayout>
        )
    }
}
